import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import { usersAPI } from '../../services/api';
import PaginatedTable from '../../components/PaginatedTable';

function UsersManager() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'parent', phone: '' });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const { t } = useI18n();

  const loadUsers = async () => {
    try {
      const { data } = await usersAPI.list();
      setUsers(data);
    } catch (err) { setError('Failed to load users.'); }
  };

  useEffect(() => { loadUsers(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (editingId) {
        const payload = { ...form };
        if (!payload.password) delete payload.password;
        await usersAPI.update(editingId, payload);
      } else {
        await usersAPI.create(form);
      }
      setForm({ name: '', email: '', password: '', role: 'parent', phone: '' });
      setEditingId(null);
      loadUsers();
    } catch (err) {
      setError(err.response?.data?.error || 'Operation failed.');
    }
  };

  const handleEdit = (user) => {
    setEditingId(user.id);
    setForm({ name: user.name, email: user.email, password: '', role: user.role, phone: user.phone || '' });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Soft delete this user?')) return;
    try { await usersAPI.remove(id); loadUsers(); } catch (err) { setError('Delete failed.'); }
  };

  const columns = [
    { key: 'name', label: t('name') },
    { key: 'email', label: t('email') },
    { key: 'role', label: t('role') },
    { key: 'phone', label: t('phone') },
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <Link to="/admin" style={{ color: '#007bff', textDecoration: 'none' }}>{t('backToDashboard')}</Link>
      <h1>{t('manageUsers')}</h1>

      {error && <div style={{ background: '#fee', color: '#c00', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input placeholder={t('name')} value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required style={styles.input} />
        <input placeholder={t('email')} type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required style={styles.input} />
        <input placeholder={editingId ? t('newPassword') : t('password')} type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} required={!editingId} style={styles.input} />
        <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})} style={styles.input}>
          <option value="admin">{t('role')} Admin</option>
          <option value="driver">{t('role')} Driver</option>
          <option value="parent">{t('parent')}</option>
        </select>
        <input placeholder={t('phone')} value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} style={styles.input} />
        <button type="submit" style={styles.saveBtn}>{editingId ? t('update') : t('create')}</button>
        {editingId && <button type="button" onClick={() => { setEditingId(null); setForm({ name: '', email: '', password: '', role: 'parent', phone: '' }); }} style={styles.cancelBtn}>{t('cancel')}</button>}
      </form>

      <PaginatedTable data={users} columns={columns} searchFields={['name', 'email', 'role', 'phone']} onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
}

const styles = {
  form: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' },
  input: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', minWidth: '150px' },
  saveBtn: { padding: '8px 16px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  cancelBtn: { padding: '8px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
};

export default UsersManager;
